import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../config';

// export interface FormField {
//   name: string;
//   label: string;
//   type: 'text' | 'select' | 'textarea';
//   placeholder?: string;
//   required: boolean;
//   options?: string[];
//   fullWidth?: boolean;
// }

// export interface Template {
//   id: string;
//   title: string;
//   formTitle: string;
//   description: string;
//   fields: FormField[];
// } 



export interface Template {
  interviewingRole: any;
  id: string;
  consultantName: string;
  previousRole: string;
  presentRole: string;
  previousClient: string;
  presentClient: string;
  interviewingClient: string;
  jobDescription: string; // This will be the resolved description (placeholders replaced)
}
export interface Payload {
  id: string;
  prompt: string;
}


@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  private templates: Template[] = [
    // {
    //   id: 'medical',
    //   title: 'Medical Consultation',
    //   formTitle: 'Medical Consultation Settings',
    //   description: 'AI-powered medical consultation assistant for patient intake and symptom analysis.',
    //   fields: [
    //     { name: "patientName", label: "Patient Name", type: "text", placeholder: "Enter patient name", required: true },
    //     { name: "currentCondition", label: "Current Condition", type: "text", placeholder: "Enter current condition", required: true },
    //     { name: "specialist", label: "Consulting Specialist", type: "text", placeholder: "Enter consulting specialist", required: true },
    //     { name: "referringPhysician", label: "Referring Physician", type: "text", placeholder: "Enter referring physician", required: false },
    //     { name: "primaryComplaint", label: "Primary Complaint", type: "text", placeholder: "Enter primary complaint", required: true },
    //     { name: "previousTreatment", label: "Previous Treatment", type: "text", placeholder: "Enter previous treatment", required: false },
    //     { name: "consultationType", label: "Consultation Type", type: "select", options: ["Initial Consultation", "Follow-up", "Emergency", "Routine Check-up"], required: true, fullWidth: true },
    //     { name: "medicalHistory", label: "Medical History & Symptoms", type: "textarea", placeholder: "Describe medical history and current symptoms in detail", required: true, fullWidth: true }
    //   ]
    // },
    // {
    //   id: 'interview',
    //   title: 'Interview Settings',
    //   formTitle: 'Interview Settings',
    //   description: 'Comprehensive interview preparation and candidate evaluation assistant.',
    //   fields: [
    //     { name: "candidateName", label: "Candidate Name", type: "text", placeholder: "Enter candidate name", required: true },
    //     { name: "presentRole", label: "Present Role", type: "text", placeholder: "Enter present role", required: true },
    //     { name: "interviewingRole", label: "Interviewing Role", type: "text", placeholder: "Enter interviewing role", required: true },
    //     { name: "interviewingClient", label: "Interviewing Client", type: "text", placeholder: "Enter interviewing client name", required: true },
    //     { name: "currentClient", label: "Current Client", type: "text", placeholder: "Enter current client", required: false },
    //     { name: "previousClient", label: "Previous Client", type: "text", placeholder: "Enter previous client", required: false },
    //     { name: "interviewType", label: "Interview Type", type: "select", options: ["Technical Interview", "Behavioral Interview", "Panel Interview", "Phone Interview", "Video Interview"], required: true, fullWidth: true },
    //     { name: "jobDescription", label: "Job Description", type: "textarea", placeholder: "Paste job description here", required: true, fullWidth: true }
    //   ]
    // }
    // {
    //   id: 'support',
    //   title: 'Customer Support',
    //   formTitle: 'Customer Support Settings',
    //   description: 'Customer service assistant for handling inquiries and support tickets.',
    //   fields: [
    //     { name: "customerName", label: "Customer Name", type: "text", placeholder: "Enter customer name", required: true },
    //     { name: "issueType", label: "Issue Type", type: "text", placeholder: "Enter issue type", required: true },
    //     { name: "productService", label: "Product/Service", type: "text", placeholder: "Enter product or service", required: true },
    //     { name: "customerID", label: "Customer ID", type: "text", placeholder: "Enter customer ID", required: false },
    //     { name: "contactMethod", label: "Contact Method", type: "text", placeholder: "Enter preferred contact method", required: false },
    //     { name: "accountType", label: "Account Type", type: "text", placeholder: "Enter account type", required: false },
    //     { name: "priorityLevel", label: "Priority Level", type: "select", options: ["Low", "Medium", "High", "Critical"], required: true, fullWidth: true },
    //     { name: "issueDescription", label: "Issue Description", type: "textarea", placeholder: "Describe the customer's issue in detail", required: true, fullWidth: true }
    //   ]
    // }
  ];

  constructor(private http: HttpClient) { }


  getTemplates(): Observable<Template[]> {
    return this.http.get<Template[]>(API_URL);
  }

  getTemplateById(id: string): Observable<Template> {
    return this.http.get<Template>(`${API_URL}/prompt/${id}`);
  }


  createTemplate(template: Payload): Observable<Template> {
    return this.http.post<Template>(`${API_URL}/store`, template);
  }

  getAllPrompts(): Observable<any[]> {
    return this.http.get<any[]>(`${API_URL}/prompts`);
  }



}
